import DefaultThumbnailImage from './DefaultThumbnailImage';

export default DefaultThumbnailImage;
